/**
 * Reports depth (TASK-69) — Scheduler, Data Extracts / Custom Exports,
 * Statistics. Built over the existing reports/bookings/payments data.
 */

// ── Scheduler ────────────────────────────────────────────────────────────────

export enum ReportFrequency {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
}

export enum ReportRunStatus {
  QUEUED = 'queued',
  RUNNING = 'running',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

export interface ScheduledReport {
  id: string;
  propertyId: string;
  name: string;
  reportType: string;
  frequency: ReportFrequency;
  recipients: string[];
  isActive: boolean;
  lastRunAt: string | null;
  lastRunStatus: ReportRunStatus | null;
  nextRunAt: string | null;
  createdAt: string;
  updatedAt: string;
}

// ── Data Extracts / Custom Exports ───────────────────────────────────────────

export enum DataExtractType {
  GUEST_INFO = 'guest_info',
  AVAILABILITY_BY_ROOM_TYPE = 'availability_by_room_type',
  PAYMENT_ACTIVITY = 'payment_activity',
  CHECKOUT_REVIEW = 'checkout_review',
  REVENUE_SEGMENT = 'revenue_segment',
  BOOKED_RESERVATIONS = 'booked_reservations',
}

export interface DataExtractRequest {
  extractType: DataExtractType;
  propertyId: string;
  from: string;
  to: string;
}

/** Generic tabular extract result (also the basis for CSV export). */
export interface DataExtractResult {
  extractType: DataExtractType;
  columns: string[];
  rows: Array<Record<string, string | number | null>>;
  generatedAt: string;
}

// ── Statistics ───────────────────────────────────────────────────────────────

export interface RevenueStatistics {
  propertyId: string;
  from: string;
  to: string;
  roomRevenue: string;
  otherRevenue: string;
  totalRevenue: string;
  adr: string;
  revPar: string;
  occupancyRate: number;
}

export interface RoomSoldStatistics {
  propertyId: string;
  from: string;
  to: string;
  totalRoomNightsSold: number;
  daily: Array<{ date: string; sold: number }>;
}
